export default [
  {
    path: 'bank',
    redirect: { name: 'banks' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'banks',
        component: () => import('@pages/banks/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Bank',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Bank',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'banks-add',
        component: () => import('@pages/banks/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Bank',
          navActiveLink:'banks',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Bank',
              to: { name: 'banks' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'banks-edit',
        component: () => import('@pages/banks/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Bank',
          navActiveLink:'banks',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Bank',
              to: { name: 'banks' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      }
    ]
  }
]